(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dekodirano-book-bhs"] && !Shopify.designMode) return;
  try {
    
function setupBook(root) {
  if (root.dataset.dbReady) return;
  root.dataset.dbReady = 'true';
  const dialog = root.querySelector('.db-dialog');
  root.querySelectorAll('[data-db-zoom]').forEach(link => {
    link.addEventListener('click', event => {
      if (!dialog || !dialog.showModal) return;
      event.preventDefault();
      const img = dialog.querySelector('img');
      img.src = link.href;
      img.alt = link.dataset.dbCaption;
      dialog.querySelector('[data-db-dialog-caption]').textContent = link.dataset.dbCaption;
      dialog.showModal();
    });
  });
  const sticky = root.querySelector('[data-db-sticky]');
  const hero = root.querySelector('.db-hero');
  const buy = root.querySelector('.db-purchase');
  if (!sticky || !hero || !buy || !('IntersectionObserver' in window)) return;
  const footer = root.ownerDocument.querySelector('footer');
  const state = { past: false, buying: false, footer: false };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.target === hero) state.past = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      if (entry.target === buy) state.buying = entry.isIntersecting;
      if (entry.target === footer) state.footer = entry.isIntersecting;
    });
    sticky.hidden = !state.past || state.buying || state.footer;
  });
  observer.observe(hero);
  observer.observe(buy);
  if (footer) observer.observe(footer);
  const unload = event => {
    if (!event.target.contains(root)) return;
    observer.disconnect();
    document.removeEventListener('shopify:section:unload', unload);
  };
  document.addEventListener('shopify:section:unload', unload);
}
document.querySelectorAll('[data-db-book]').forEach(setupBook);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-db-book]').forEach(setupBook));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dekodirano-home-bhs"] && !Shopify.designMode) return;
  try {
    
function setupGuide(root){if(!root||root.dataset.guideReady)return;root.dataset.guideReady='true';const success=root.querySelector('.dh-guide-success');const error=root.querySelector('.dh-guide-errors');if(success||error){const feedback=success||error;feedback.setAttribute('tabindex','-1');feedback.focus();}}
document.querySelectorAll('.dh-gift-launch').forEach(setupGuide);
document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('.dh-gift-launch').forEach(setupGuide);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dekodirano-premium-bhs"]) return;
  try {
    
function setupPremium(root){
  if(!root||root.dataset.dpReady)return;
  root.dataset.dpReady='true';
  const feedback=root.querySelector('.dp-wait-success,.dp-wait-errors');
  if(feedback){feedback.setAttribute('tabindex','-1');feedback.focus();}
  const hero=root.querySelector('[data-dp-hero]');
  const buy=root.querySelector('[data-dp-buy]');
  const sticky=root.querySelector('[data-dp-sticky]');
  if(!hero||!buy||!sticky||!('IntersectionObserver' in window))return;
  const footer=root.ownerDocument.querySelector('footer');
  let footerVisible=false;
  let heroAbove=false;
  let buyVisible=false;
  const update=()=>{sticky.hidden=!heroAbove||buyVisible||footerVisible;};
  const observer=new IntersectionObserver(entries=>{
    for(const entry of entries){
      if(entry.target===hero)heroAbove=!entry.isIntersecting&&entry.boundingClientRect.bottom<=0;
      if(entry.target===buy)buyVisible=entry.isIntersecting;
      if(entry.target===footer)footerVisible=entry.isIntersecting;
    }
    update();
  });
  observer.observe(hero);observer.observe(buy);if(footer)observer.observe(footer);
  const cleanup=event=>{
    if(event.target.contains(root)){observer.disconnect();document.removeEventListener('shopify:section:unload',cleanup);}
  };
  document.addEventListener('shopify:section:unload',cleanup);
}
document.querySelectorAll('[data-dp-program]').forEach(setupPremium);
document.addEventListener('shopify:section:load',event=>{
  event.target.querySelectorAll('[data-dp-program]').forEach(setupPremium);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dekodirano-session-bhs"]) return;
  try {
    
function setupWorkForm(root){if(root.dataset.dkReady)return;root.dataset.dkReady='true';const feedback=root.querySelector('.dk-success,.dk-errors');if(feedback){feedback.setAttribute('tabindex','-1');feedback.focus();}}
document.querySelectorAll('.dk-work').forEach(setupWorkForm);
document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('.dk-work').forEach(setupWorkForm);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
